import React from 'react';

type VisibilityHook = { visible: boolean; show: VoidFunction; hide: VoidFunction; toggle: VoidFunction };

export const useVisibility = (isVisible: boolean = false): VisibilityHook => {
    const [visible, setVisible] = React.useState<boolean>(isVisible);
    const hide = () => setVisible(false);
    const show = () => setVisible(true);
    const toggle = () => setVisible((prev) => !prev);
    return { visible, show, hide, toggle };
};

const VisibilityContext = React.createContext<VisibilityHook>({
    visible: false,
    show: () => {},
    hide: () => {},
    toggle: () => {},
});

export const VisibilityProvider = ({ children }: { children: React.ReactNode }) => {
    const controller = useVisibility();
    return <VisibilityContext.Provider value={controller}>{children}</VisibilityContext.Provider>;
};
export const useVisibilityContext = () => React.useContext(VisibilityContext);
